module.exports = __webpack_public_path__ + "img/SyMshel.aff4d972.svg";